export default "__VITE_ASSET__DDurFRPf__"